import confetti from 'canvas-confetti';
import QuizManager from "../quizes/quiz-manager";
import { fire } from "../utils/events";
import getPersistentUrl from "../utils/persistent-path";
import { goToNextVisibleSlide } from "../slides/add-slide-controls";

const PATH_AUDIO_SUCCESS = {
    path1: "audio/success1.wav",
    // path2: "audio/success2.wav",
};

const PATH_AUDIO_FAIL = {
    // path1: "audio/fail1.wav",
    // path2: "audio/fail2.wav",
};

const RewardScreens = new class RewardScreens {
    constructor() {
        // this.type = Q3.data.setups.currentRewardStyle || "Comic";
        this.audio = new Audio();
    }

    init() {
        if (Q3.editMode || QuizManager.quizCount === 0) return;

        this.callbacks = [];

        this.type = "Comic";
        this.wrap = $('<div id="reward-screen"></div>');
        this.canvas = $('<canvas id="reward-screen-canvas"/>');
        this.message = $('<div id="reward-message"></div>');
        this.modal = $('<div id="reward-modal">');

        this.rewards = {
            "Comic": {
                reward1: $('<div class="anim-wrap"><div class="img-popup i1"><img src="/images/rewardScreens/1-1.png"></div><div class="img-popup i2"><img src="/images/rewardScreens/1-2.png"></div><div class="img-popup i3"><img src="/images/rewardScreens/1-3.png"></div><div class="img-popup i4"><img src="/images/rewardScreens/thumbs-up.png"></div></div>'),
                reward2: $('<div class="anim-wrap"><div class="img-popup i1"><img src="/images/rewardScreens/2-1.png"></div><div class="img-popup i2"><img src="/images/rewardScreens/2-2.png"></div><div class="img-popup i3"><img src="/images/rewardScreens/2-3.png"></div><div class="img-popup i4"><img src="/images/rewardScreens/thumbs-up.png"></div></div>'),
                reward3: $('<div class="anim-wrap"><div class="img-popup i1"><img src="/images/rewardScreens/3-1.png"></div><div class="img-popup i2"><img src="/images/rewardScreens/3-2.png"></div><div class="img-popup i3"><img src="/images/rewardScreens/3-3.png"></div><div class="img-popup i4"><img src="/images/rewardScreens/thumbs-up.png"></div></div>'),
            },
        };

        this.failures = {
            "Comic": {
                failure1: $('<div class="anim-wrap"><div class="img-popup i1"><img src="/images/rewardScreens/4-1.png"></div><div class="img-popup i2"><img src="/images/rewardScreens/4-2.png"></div><div class="img-popup i3"><img src="/images/rewardScreens/4-3.png"></div><div class="img-popup i4"><img src="/images/rewardScreens/thumbs-down.png"></div></div>'),
                failure2: $('<div class="anim-wrap"><div class="img-popup i1"><img src="/images/rewardScreens/5-1.png"></div><div class="img-popup i2"><img src="/images/rewardScreens/5-2.png"></div><div class="img-popup i3"><img src="/images/rewardScreens/5-3.png"></div><div class="img-popup i4"><img src="/images/rewardScreens/thumbs-down.png"></div></div>'),
                failure3: $('<div class="anim-wrap"><div class="img-popup i1"><img src="/images/rewardScreens/6-1.png"></div><div class="img-popup i2"><img src="/images/rewardScreens/6-2.png"></div><div class="img-popup i3"><img src="/images/rewardScreens/5-3.png"></div><div class="img-popup i4"><img src="/images/rewardScreens/thumbs-down.png"></div></div>'),
            },
        };

        this.wrap.append(this.message, this.modal, this.canvas);

        $(Q3.container).append(this.wrap);

        this.hideModal = this.hideModal.bind(this);
    }

    setNextSlide() {
        goToNextVisibleSlide({ userAction: true, ignore: true, quizSubmit: true })
    }

    showConfetti() {
        this.showingConfetti = true;
        return new Promise((resolve) => {
            function fire1() {
                confetti({
                    particleCount: 200,
                    angle: 60,
                    spread: 55,
                    origin: { x: 0 }
                });
                confetti({
                    particleCount: 200,
                    angle: 120,
                    spread: 55,
                    origin: { x: 1 }
                });
            }
            function fire2() {
                var count = 200;
                var defaults = {
                    origin: { y: 0.7 }
                };

                function f2(particleRatio, opts) {
                    confetti(Object.assign({}, defaults, opts, {
                        particleCount: Math.floor(count * particleRatio)
                    }));
                }

                f2(0.25, {
                    spread: 26,
                    startVelocity: 55,
                });
                f2(0.2, {
                    spread: 60,
                });
                f2(0.35, {
                    spread: 100,
                    decay: 0.91,
                    scalar: 0.8
                });
                f2(0.1, {
                    spread: 120,
                    startVelocity: 25,
                    decay: 0.92,
                    scalar: 1.2
                });
                f2(0.1, {
                    spread: 120,
                    startVelocity: 45,
                });
            }
            let arr = [fire2];
            let fn = arr[Math.floor(Math.random() * arr.length)]
            setTimeout(() => {
                fn()
            }, 200)
            setTimeout(() => {
                fn()
            }, 400)
            setTimeout(() => {
                fn()
            }, 600)
            setTimeout(() => {
                fn()
                resolve();
            }, 800)
        })
    }

    showRandomReward({ playAudio = false, audioPath = false, message = null, setNextSlide = true, callbacks = null } = {}) {
        message && this.message.html(message);
        callbacks && this.callbacks.push(...callbacks);
        setNextSlide && this.callbacks.push(this.setNextSlide.bind(this));

        let reward = "reward" + Math.ceil(Math.random() * Object.keys(this.rewards[this.type]).length);

        this.modal.empty().append(this.rewards[this.type][reward]);

        this.wrap[0].className = "theme-" + this.type.toLowerCase();
        this.wrap.addClass(reward).fadeIn();
        if (Q3.browserCapabilities.renderQuality !== 0) this.showConfetti();
        if (playAudio) {
            let path;
            if (audioPath) {
                path = `${Q3.s3Url}${audioPath}`;
            } else {
                let key = Object.keys(PATH_AUDIO_SUCCESS)[Math.floor(Math.random() * Object.keys(PATH_AUDIO_SUCCESS).length)];
                path = key ? getPersistentUrl(PATH_AUDIO_SUCCESS[key]) : false;
            }
            if (path) {
                Q3.SlideManager.activeSlideAudio.pause();
                this.audio.setAttribute("src", path);

                this.audio.play();

                this.audio.addEventListener("ended", this.hideModal)
            }

            setTimeout(() => this.wrap.on("click", this.hideModal), 1500);

        } else {
            this.timeout = setTimeout(() => this.hideModal(), 2000);

            setTimeout(() => this.wrap.on("click", this.hideModal), 1500);
        }
    }

    showRandomFailure({ playAudio = false, audioPath = false, message = null, setNextSlide = true, callbacks = null } = {}) {
        message && this.message.html(message);
        callbacks && this.callbacks.push(...callbacks);
        setNextSlide && this.callbacks.push(this.setNextSlide.bind(this));

        let failure = "failure" + Math.ceil(Math.random() * Object.keys(this.failures[this.type]).length);

        this.modal.empty().append(this.failures[this.type][failure]);
        this.wrap[0].className = "theme-" + this.type.toLowerCase();
        this.wrap.addClass(failure).fadeIn();

        let timeOut = 2000;
        if (message) { timeOut = 5000; }

        if (playAudio) {
            let path;
            if (audioPath) {
                path = `${Q3.s3Url}${audioPath}`;
            } else {
                let key = Object.keys(PATH_AUDIO_FAIL)[Math.floor(Math.random() * Object.keys(PATH_AUDIO_FAIL).length)];
                path = key ? getPersistentUrl(PATH_AUDIO_FAIL[key]) : false;
            }
            if (path) {
                Q3.SlideManager.activeSlideAudio.pause();
                this.audio.setAttribute("src", path);

                this.audio.play();

                this.audio.addEventListener("ended", this.hideModal)
            }

            setTimeout(() => this.wrap.on("click", this.hideModal), 1500);

        } else {
            this.timeout = setTimeout(() => this.hideModal(), timeOut);
            setTimeout(() => this.wrap.on("click", this.hideModal), 1500);
        }
    }

    hideModal() {
        if  (this.modal.hasClass("hide")) return;

        clearTimeout(this.timeout);

        this.modal.addClass("hide");
        this.audio.removeEventListener("ended", this.hideModal);
        this.audio.setAttribute("src", "");
        setTimeout(() => {
            this.message.html("");
            this.modal.empty().removeClass();
            this.wrap[0].className = "theme-" + this.type.toLowerCase();
            this.wrap.fadeOut();
            if (this.showingConfetti) {
                confetti.reset();
            }
            this.showingConfetti = false;
            this.wrap.off("click", this.hideModal);
            this.callbacks.forEach(cb => {
                if (typeof cb === "function") cb();
            });

            this.callbacks = [];

            if (QuizManager.answers === QuizManager.quizCount) fire("showquizscore");
        }, 500)
    }

    showFeedbackMessage({ message }) {
        this.message.html(message);

        this.wrap[0].className = "theme-" + this.type.toLowerCase();
        this.wrap.fadeIn();

        this.timeout = setTimeout(() => this.hideFeedbackMessage(), 5000);

        setTimeout(() => this.wrap.on("click", () => this.hideFeedbackMessage()), 1500)
    }

    hideFeedbackMessage() {
        clearTimeout(this.timeout);

        setTimeout(() => {
            this.message.html("");
            this.wrap[0].className = "theme-" + this.type.toLowerCase();
            this.wrap.fadeOut();
            this.wrap.off("click", this.hideFeedbackMessage);
        }, 500)
    }
}
export default RewardScreens;
export { RewardScreens };
